export default "__VITE_ASSET__KtIwWSTC__"